import { Socket } from 'phoenix'
import once from 'lodash/once'

let socket = null
let channel = null

function metaSocialConnect() {
  socket = new Socket('/meta-social', { params: {} })
  socket.connect()

  channel = socket.channel('metadata', {})
  channel.join()
}

const metaSocialConnectOnce = once(metaSocialConnect)

export default {
  namespaced: true,

  state: { metaSocial: null },

  getters: {
    metaSocial: (state) => state.metaSocial
  },

  mutations: {
    metaSocialFetched(state, { metaSocialData }) {
      state.metaSocial = metaSocialData
    },

    resetState(state) {
      state.metaSocial = null
    }
  },

  actions: {
    async fetch({ commit }, url) {
      return new Promise(function (resolve, reject) {
        metaSocialConnectOnce()

        channel.push('fetch', { path: url }).receive('ok', (metaSocialData) => {
          commit('metaSocialFetched', { metaSocialData })
          resolve(metaSocialData)
        })
      })
    }
  }
}
